// Force zero gain/loss is its own role permission, apart from categorize (BW4-3239). A role without
// it does not see the checkbox on lines that are not forced, and sees it locked on lines that are, so
// an existing override stays visible but can be neither set nor cleared. The API refuses the change
// either way.
export function forceZeroGainLossControl(
  canForceZeroGainLoss: boolean,
  forced: boolean | undefined
): { visible: boolean; disabled: boolean } {
  return { visible: canForceZeroGainLoss || forced === true, disabled: !canForceZeroGainLoss };
}
